
webpack.register(
    'modules/live-video-pop-out/live-poll/live-poll',
    function() {
        return import('modules/live-video-pop-out/live-poll/live-poll');
    },
    true
);